export function getSite(state, siteId) {
  const {list} = state.sites
  if (!list) return null

  if (siteId === 'all') return siteId

  return list[siteId] || null
}

export function getSites(state) {
  const {list} = state.sites
  if (!list) return null

  return Object.keys(list).reduce((acc, key) => acc.concat(list[key]), [])
}

export function getSitesWithMerchants(state) {
  const {sites: {list}, merchants} = state
  if (!list || !merchants) return null

  return Object.keys(list).reduce((acc, key) => {
    const site = list[key]
    site.merchantName = merchants[site.merchantId].name
    return acc.concat(site)
  }, [])
}

export function getMerchantBySite(state, siteId) {
  const {sites: {list}, merchants} = state
  if (!list || !merchants) return null

  const {merchantId} = list[siteId] || {}

  if (!merchantId) return null

  return merchants[merchantId]
}

export function getLastSite(state) {
  const sites = getSites(state)

  return sites && sites.concat().pop()
}



// WEBPACK FOOTER //
// ./client/redux/modules/sites/selectors.js